import { AlertTriangle } from "lucide-react";
import { Button } from "@/components/ui/button";
import usePageTitle from "@/hooks/usePageTitle";

const GiftCardCancel = () => {
  usePageTitle("Paiement annulé | Bio Beauté Zen");
  
  return (
    <main className="pt-24 pb-16">
      <div className="container mx-auto px-4 max-w-2xl">
        <div className="bg-white rounded-lg shadow-lg p-8 text-center">
          <AlertTriangle className="h-16 w-16 text-amber-500 mx-auto mb-4" />
          <h1 className="font-playfair text-3xl font-semibold text-bbz-text mb-4">
            Paiement annulé
          </h1>
          <p className="text-lg text-bbz-text/70 mb-4">
            Vous avez annulé le processus de paiement.
          </p>
          <p className="text-sm text-bbz-text/60 mb-8">
            Aucun montant n'a été débité de votre compte.
          </p>
          
          <div className="bg-bbz-beige/30 p-6 rounded-lg mb-8">
            <h3 className="font-medium mb-3">Besoin d'aide ?</h3>
            <p className="text-sm text-bbz-text/70 mb-4">
              Si vous avez rencontré un problème lors du paiement ou si vous avez des questions, contactez-nous :
            </p>
            <ul className="text-sm space-y-1 text-bbz-text/70">
              <li>📞 Téléphone : 04 99 53 83 08</li>
              <li>📧 Email : biobeautezen.institut@gmail.com</li>
            </ul>
          </div>
          
          <div className="flex flex-col md:flex-row gap-4 justify-center">
            <Button asChild variant="outline">
              <a href="/">Retour à l'accueil</a>
            </Button>
            <Button asChild>
              <a href="/bon-cadeaux-estheticienne-bio-montpellier">Réessayer le paiement</a>
            </Button>
          </div>
        </div>
      </div>
    </main>
  );
};

export default GiftCardCancel;
